export default __webpack_public_path__ + "static/media/icon.marker.974f48c2.svg";